export default __webpack_public_path__ + "static/media/dashboardFilled.0551d8ed.svg";